import React, { FC } from "react";
import {
  LookupItemModel,
  LookupTypeEnum,
  SearchPanelPropsModel,
  TransactionReportSearchParamsModel,
} from "../../../models";
import { Form } from "react-bootstrap";
import { getLabelName } from "../../../utils";
import {
  InputDatePicker,
  SelectBox,
  ButtonBox,
  PrivilegesChecker,
} from "../..";
import { useLookups } from "../../../hooks";

export const ReportOrderStatusLogSearchPanel: FC<
  SearchPanelPropsModel<TransactionReportSearchParamsModel>
> = ({ setLoading, searchParams, setSearchParams, handelSearch, formId }) => {
  //#region state
  const { getLookupItems } = useLookups(setLoading, [
    LookupTypeEnum.ReportTypes,
    LookupTypeEnum.Customers,
    LookupTypeEnum.Users,
    LookupTypeEnum.Employee,
    LookupTypeEnum.CostCenters,
    LookupTypeEnum.Currency,
    LookupTypeEnum.AllCategories,
    LookupTypeEnum.DaysOfWeek,
  ]);
  //#endregion
  //#region html
  return (
    <>
      <Form>
        <div className="row row-cols-1 row-cols-xxl-3 row-cols-xl-3 row-cols-lg-3 row-cols-md-3 row-cols-sm-1 g-sm-2 g-md-4 align-items-start">
          <InputDatePicker
            className="form-control"
            selectedDate={searchParams.fromDate}
            isClearable
            InputLabel={"From Date"}
            selectsStart
            startDate={searchParams.fromDate}
            endDate={searchParams.toDate}
            onChange={(date) => {
              const obj = { ...searchParams };
              obj.fromDate = date === null ? undefined : date;
              setSearchParams(obj);
            }}
          />
          <InputDatePicker
            className="form-control"
            selectedDate={searchParams.toDate}
            isClearable
            InputLabel={"To Date"}
            selectsEnd
            startDate={searchParams.fromDate}
            endDate={searchParams.toDate}
            minDate={searchParams.fromDate}
            onChange={(date) => {
              const obj = { ...searchParams };
              obj.toDate = date === null ? undefined : date;
              setSearchParams(obj);
            }}
          />

          <SelectBox
            labelName="Customer"
            isSingleSelect={true}
            selectedValues={
              searchParams.custmerId
                ? [searchParams.custmerId.toString()]
                : [""]
            }
            source={getLookupItems(LookupTypeEnum.Customers, true)}
            onStatusChange={(e: LookupItemModel) => {
              const obj = { ...searchParams };
              if (e == null) {
                obj.custmerId = undefined;
              } else {
                obj.custmerId =
                  e.value === "" || e.value === null
                    ? undefined
                    : parseInt(e.value);
              }
              setSearchParams(obj);
            }}
          />
          <SelectBox
            labelName="Cashier"
            isSingleSelect={true}
            selectedValues={
              searchParams.userId ? [searchParams.userId.toString()] : [""]
            }
            source={getLookupItems(LookupTypeEnum.Users, true)}
            onStatusChange={(e: LookupItemModel) => {
              const obj = { ...searchParams };
              if (e == null) {
                obj.userId = undefined;
              } else {
                obj.userId =
                  e.value === "" || e.value === null
                    ? undefined
                    : parseInt(e.value);
              }
              setSearchParams(obj);
            }}
          />
          <SelectBox
            labelName="Employee"
            isSingleSelect={true}
            selectedValues={
              searchParams.employeeId
                ? [searchParams.employeeId.toString()]
                : [""]
            }
            source={getLookupItems(LookupTypeEnum.Employee, true)}
            onStatusChange={(e: LookupItemModel) => {
              const obj = { ...searchParams };
              if (e == null) {
                obj.employeeId = undefined;
              } else {
                obj.employeeId =
                  e.value === "" || e.value === null
                    ? undefined
                    : parseInt(e.value);
              }
              setSearchParams(obj);
            }}
          />

          <SelectBox
            labelName="Currency"
            isSingleSelect={true}
            selectedValues={
              searchParams.currencyId
                ? [searchParams.currencyId.toString()]
                : [""]
            }
            source={getLookupItems(LookupTypeEnum.Currency, true)}
            onStatusChange={(e: LookupItemModel) => {
              const obj = { ...searchParams };
              if (e == null) {
                obj.currencyId = undefined;
              } else {
                obj.currencyId =
                  e.value === "" || e.value === null
                    ? undefined
                    : parseInt(e.value);
              }
              setSearchParams(obj);
            }}
          />
        </div>
        <PrivilegesChecker formId={formId} action="EnableSearch">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
            <ButtonBox
              iconType="magnify"
              className="btn-gradient-primary mx-3 btn-fw"
              variant="outline-primary"
              onClick={handelSearch}
            >
              {getLabelName("Search")}
            </ButtonBox>
          </div>
        </PrivilegesChecker>
      </Form>
      {/* </Card.Body>
      </Card> */}
    </>
  );
  //#endregion
};
